import { render } from "./UploadModalPreTest.vue?vue&type=template&id=18116f63"
import script from "./UploadModalPreTest.vue?vue&type=script&lang=js"
export * from "./UploadModalPreTest.vue?vue&type=script&lang=js"

import "./UploadModalPreTest.vue?vue&type=style&index=0&id=18116f63&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__